import { GetGuestsForFilterActionTypes, GetGuestsForFilterState, GET_GUESTS_FOR_FILTER_FAILURE, GET_GUESTS_FOR_FILTER_REQUEST, GET_GUESTS_FOR_FILTER_SUCCESS } from "./types";


const defaultState: GetGuestsForFilterState = {
  isLoading: false,
  errorMessage: ""
};

export default function getGuestsForFilter(state = defaultState, action: GetGuestsForFilterActionTypes): GetGuestsForFilterState {
  switch (action.type) {
    case GET_GUESTS_FOR_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_GUESTS_FOR_FILTER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_GUESTS_FOR_FILTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};